import { useEffect } from 'react'
import { registerDayAheadBidTablePendingEdits } from '../../store/dayAheadBidTableStore'

export function usePendingBidEditsGuard(
  hasPendingEdits: boolean,
  discard: () => void,
  save: (() => void) | null,
  isSavePending: boolean
): void {
  useEffect(() => {
    registerDayAheadBidTablePendingEdits(hasPendingEdits, discard, save, isSavePending)

    return () => {
      registerDayAheadBidTablePendingEdits(false, null, null, false)
    }
  }, [hasPendingEdits, discard, save, isSavePending])

  useEffect(() => {
    if (!hasPendingEdits) {
      return
    }

    function handleBeforeUnload(event: BeforeUnloadEvent): void {
      event.preventDefault()
      event.returnValue = ''
    }

    window.addEventListener('beforeunload', handleBeforeUnload)
    return () => window.removeEventListener('beforeunload', handleBeforeUnload)
  }, [hasPendingEdits])
}
